import { getAuthHeaders } from "../auth";
import { CREATE_EDIT_RESOURCE_URL, RESOURCE_DETAILS_URL, FETCH_RESOURCES_LIST, FETCH_ACCOUNTS_BY_QUERY_URL, BULK_UPDATE_RESOURCE_STATUS_URL, BULK_DELETE_RESOURCES_URL } from "../constants";
export const getResourcePayload = (id) => {
    return {
        url: `${RESOURCE_DETAILS_URL}?ResourceID=${id}`,
        options: {
            method: "GET",
            headers: getAuthHeaders()
        }
    }
}
export const createOrEditResourcePayload = (isCreateMode, details) => {
    const { resourceType, resourceName, resourceEmail,
        resourceId, resourceLocation, resourcePhoneNumber,
        resourceStatus } = details;
    const reqPayload = {
        "ResourceID": isCreateMode ? null : resourceId,
        "ResourceName": resourceName,
        "AccountType": resourceType,
        "Email": resourceEmail,
        "Phone": resourcePhoneNumber,
        "Address": resourceLocation,
        "Status": resourceStatus
    }
    return {
        url: `${CREATE_EDIT_RESOURCE_URL}`,
        options: {
            method: "POST",
            headers: getAuthHeaders(),
            body: JSON.stringify(reqPayload)
        }
    }
}

export const getResourceDetailsServiceConfig = (resourceId) => {
    return getResourcePayload(resourceId);
}
export const getResourcesListServiceConfig = (queryString) => {
    return {
        url: `${FETCH_RESOURCES_LIST}?${queryString}`,
        options: {
            method: "GET",
            headers: getAuthHeaders()
        }
    }
}

export const getAccountSearchReqConfig = (query) => {
    return {
        url: `${FETCH_ACCOUNTS_BY_QUERY_URL}?Search=${query}`,
        options: {
            method: "GET",
            headers: getAuthHeaders()
        }
    }
}

export const getBulkStatusUpdateServiceConfig = (ids, status) => {
    const payload = {
        "ResourceIDs": ids.join(','),
        "Status": status
    }
    return {
        url:BULK_UPDATE_RESOURCE_STATUS_URL,
        options:{
            method:"PUT",
            headers:getAuthHeaders(),
            body:JSON.stringify(payload)
        }
    }
}

export const getBulkDeleteUsersServiceConfig = (ids)=>{
    return {
        url:`${BULK_DELETE_RESOURCES_URL}?ResourceIds=${ids.join(',')}`,
        options:{
            method:"DELETE",
            headers:getAuthHeaders()
        }
    }
}